/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Grid, Typography } from "@mui/material";
import { fonts, themes } from "../../../common/themes/themes";
import "./Claims.css";
import AirTicketsController from "../../../domain/myProfile/claims/AirTickets/AirTicketsController";
import ClaimListController from "../../../domain/myProfile/claims/ClaimList/ClaimListController";
import ClaimHistoryController from "../../../domain/myProfile/claims/ClaimHistory/ClaimHistoryController";
import { useAppSelector } from "../../../infra/hooks";

interface claimProp {
  trans?: any;
  i18n?: any;
}
const ClaimsPresenter = ({ trans, i18n }: claimProp) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <Grid
      container
      style={{
        display: "flex",
        flexWrap: "nowrap",
        marginTop: isHRView ? "" : "4em",
        width: "100vw",
        paddingRight: "8em",
        overflowX: "hidden",
      }}
    >

      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: "#F5F5FA",
          width: "100%",
          padding: "1.75em",
          marginLeft:
            isHRView && i18n.language == "en"
              ? "11em"
              : !isHRView && i18n.language == "en"
              ? "14em"
              : "",
          marginRight: i18n.language == "ar" ? "15em" : "",
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? "2em" : "",
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: "100%",
              height: "80px",
            }}
          >
            <Grid
              container
              style={{
                width: "auto",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "10px",
                opacity: "1",
                display: "flex",
                flexDirection: "row",
                paddingTop: "1em",
                paddingBottom: "1em",
                paddingLeft: "1em",
                paddingRight: "1em",
              }}
            >
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.header,
                    color: themes.blackDefault,
                    fontWeight: "bold",
                  }}
                >
                  {trans("My Claims")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid
              container
              spacing={2}
              style={{
                width: "auto",
                marginBottom: "2em",
              }}
            >
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <AirTicketsController />
              </Grid>

              <Grid item xs={4} sm={4} md={4} lg={4}>
                <ClaimListController />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <ClaimHistoryController />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ClaimsPresenter;
